import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Estilos do visual cartoon (mesmo estilo dos stories do Instagram)
import '../../components/cartoon/cartoon.css';

// Seções da página, na ordem em que aparecem
import Navbar from '../../components/Navbar';
import Hero from '../../components/Hero';
import About from '../../components/About';
import Pillars from '../../components/Pillars';
import Blends from '../../components/Blends';
import Preparo from '../../components/Preparo';
import CTA from '../../components/CTA';
import Contact from '../../components/Contact';
import Footer from '../../components/Footer';

export default function LoopCoffee() {
    const { hash } = useLocation();

    // Links from other routes (e.g. the empty cart's "/#bitbean") land on their section, not the top.
    useEffect(() => {
        const target = hash && document.getElementById(hash.slice(1));
        if (target) {
            target.scrollIntoView();
        } else {
            window.scrollTo(0, 0);
        }
    }, [hash]);

    return (
        <>
            <Navbar />
            <main>
                <Hero />          {/* Topo: "Seu primeiro café especial começa aqui." */}
                <About />         {/* Sobre a Loop */}
                <Pillars />       {/* Beba. Inspire. Repita. */}
                <Blends />        {/* O BitBean (produto) */}
                <Preparo />       {/* Como preparar o coado */}
                <CTA />           {/* Chamada para comprar */}
                <Contact />       {/* Contato */}
            </main>
            <Footer />
            <style>{`
                html { scroll-behavior: smooth; }
                ::selection { background: #BE1E2D; color: #fff; }
            `}</style>
        </>
    );
}
